import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import downloadbuttonres1 from "../assets/images/download_button.png";
import downloadbuttonres2 from "../assets/images/download_button2.png";
import Vectornew from "../assets/images/Vector-new.png";
import backgroundrestsec from "../assets/images/bg-app.png";
import module from "../assets/images/moudle_res.png";
import GroupsIcon from '@mui/icons-material/Groups';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import carefor1 from "../assets/images/carefor-1.png";
import carefor2 from "../assets/images/carefor-2.png";
import carefor3 from "../assets/images/carefor-3.png";
import carefor4 from "../assets/images/carefor-4.png";
import carefor5 from "../assets/images/carefor-5.png";
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import doctorRegister from "../assets/images/doctorRegister.jpg";
import caregiverRegister from "../assets/images/caregiverRegister.jpg";

import "./Registration.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import nurgincareimg1 from "../assets/images/nurgincare_img_1.png";

export default function Registration() {
  return (
    <>
      <Header />

      <div
        className="registration_outer"
        style={{ backgroundImage: `url(${backgroundrestsec})` }}
      >
        <div
          className="for_vector_back"
          style={{ backgroundImage: `url(${Vectornew})` }}
        ></div>
        <div className="container-fluid">
          <div className="registration_inner">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <div className="rest_text_sec">
                  <span>Download the CareAtHome App</span>
                  <h1>
                    Trusted by Thousands of Families for Reliable Home
                    Healthcare Services.
                  </h1>
                  <p>
                    Access trusted healthcare services anytime, anywhere. Book
                    doctors, nursing care, physiotherapy, lab tests, medicines,
                    and home care services with just a few taps. Experience
                    seamless healthcare management from the comfort of your
                    home.
                  </p>
                  <div className="downd_btnss">
                    <Link
                      to="https://play.google.com/store/apps/details?id=com.letscare"
                      target="_blank"
                    >
                      <img src={downloadbuttonres1} alt="downloadbutton-1" />
                    </Link>
                    <Link
                      to="https://play.google.com/store/apps/details?id=com.letscare"
                      target="_blank"
                    >
                      <img src={downloadbuttonres2} alt="downloadbutton-2" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-12 ">
                <div className="rest_img_sec">
                  <img src={module} alt="module" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="registration-process-outer">
        <div className="container">
          <div className="registeration-heading">
            <h2>CareAtHome Partner Registration — Steps</h2>
          </div>
        </div>

        <div class="partner-process">
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">1.</span>
              <h3>Login / Sign Up</h3>
              <p>
                Create an account with your mobile number and OTP, or log in if
                you're already registered.
              </p>
            </div>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">2.</span>
              <h3>Personal Details</h3>
              <p>
                Enter your name, email, phone, date of birth, gender, and
                address.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">3.</span>
              <h3>Primary Service</h3>
              <p>Choose whether you're a Caregiver or a Doctor Consultant.</p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">4.</span>
              <h3>Service Type</h3>
              <p>
                Select your exact role: Nursing Care, Physiotherapist, or
                Bedside Attendant.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">5.</span>
              <h3>Specializations</h3>
              <p>
                Pick the cases you can handle (e.g. ICU-at-Home, Oncology,
                Palliative Care) and whether you take Short Term or Long Term
                cases.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">6.</span>
              <h3>Skills & Category</h3>
              <p>
                Tick your specific clinical skills so we can match you with the
                right patients.
              </p>
            </div>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">7.</span>
              <h3>Availability</h3>
              <p>
                Set your available days and time slots, or toggle
                "Flexible/On-call."
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">8.</span>
              <h3>Qualifications & Documents</h3>
              <p>
                Add your highest qualification and upload required documents
                (ID, registration certificate, experience certificate).
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">9.</span>
              <h3>Review & Submit</h3>
              <p>Check all details and submit for verification.</p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">10.</span>
              <h3>Registration Successful</h3>
              <p>
                Your profile is reviewed within 24–48 hours; once approved, you
                get dashboard access and start receiving patient requests.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
        </div>
      </div> */}
      

     <div className="for_care_section">
       <div className="container-fluid">
        <div className="heading_care_for">
             <h2 className="heading-about">Modern Care Management For  <span>Healthcare</span> Providers</h2>
             <p className="pera-about">Empowering healthcare teams with smart tools, real-time monitoring, and streamlined patient management.</p>
          </div>
         <div className="inner_for_care"> 
            <div className="main_box_forcare">
               <div className="icon-care">
                 <img src={carefor1} alt="carefor-1" />
               </div>
               <span>Doctors</span>
               <p>Accurate digital prescriptions, real-time patient vital monitoring, smart EHR management, and seamless tele-consultation tools.</p>
            </div>

            <div className="main_box_forcare">
               <div className="icon-care">
                 <img src={carefor2} alt="carefor-1" />
               </div>
               <span>Nurses</span>
               <p>Effortless shift tracking, daily care logs, real-time medication reminders, and instant communication with doctors.</p>
            </div>

            <div className="main_box_forcare">
               <div className="icon-care">
                 <img src={carefor3} alt="carefor-1" />
               </div>
               <span>Caregivers</span>
               <p>Personalized daily care plans, patient status updates, emergency alert systems, and easy task scheduling.</p>
            </div>

            <div className="main_box_forcare">
               <div className="icon-care">
                 <img src={carefor4} alt="carefor-1" />
               </div>
               <span>Physiotherapists</span>
               <p>Custom rehabilitation plans, exercise tracking tools, patient recovery analytics, and video session support.</p>
            </div>

            <div className="main_box_forcare">
               <div className="icon-care">
                 <img src={carefor5} alt="carefor-1" />
               </div>
               <span>Care Managers</span>
               <p>Multi-patient oversight, automated workflow scheduling, performance reporting, and resource management tools.</p>
            </div>
         </div>
       </div>
     </div>


      <div class="registration-process-outer">
        <div class="container-fluid">
          <div className="about_us_first_sec">
            <div className="row">
              <div className="col-lg-5 col-md-5 col-12">
                <div className="img_and_text_about">
                  <div className="content_nursing_img content_nursing_img_second">
                    <img src={caregiverRegister} alt="resistration-img-1" />
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-7 col-12">
                <div className="about_content">
                  <p className="title-about">Caregiver Services at Home</p>
                  <h2 className="heading-about">
                    Compassionate Care and <span> Professional Support,</span>{" "}
                    Right at Your Home
                  </h2>
                  <p className="pera-about">
                    Our caregiver services are designed to provide personalized
                    care, comfort, and support to patients in the familiar
                    surroundings of their homes. Whether your loved one needs
                    professional nursing assistance, physiotherapy for recovery
                    and improved mobility, or a bedside attendant for everyday
                    support, our dedicated care team is here to help.{" "}
                  </p>
                  

                  <div className="icon_and_point_res">
  <div className="main_sec_ip">
    <div className="card_header_top">
      <div className="main_sec_ip_icon">
        <GroupsIcon />
      </div>
      <span className="card_badge">+45% REACH</span>
    </div>
    <span>More Patients</span>
    <p>Get discovered by thousands of patients seeking care in your local area.</p>
  </div>

  <div className="main_sec_ip">
    <div className="card_header_top">
      <div className="main_sec_ip_icon">
        <MoneyOffIcon />
      </div>
      <span className="card_badge">100% EARNINGS</span>
    </div>
    <span>Zero Commission</span>
    <p>You keep 100% of what you earn with transparent, direct payout tracking.</p>
  </div>

  <div className="main_sec_ip">
    <div className="card_header_top">
      <div className="main_sec_ip_icon">
        <CalendarMonthIcon />
      </div>
      <span className="card_badge">REAL-TIME SYNC</span>
    </div>
    <span>Smart & Simple</span>
    <p>Effortlessly manage bookings, appointments & patient histories in one portal.</p>
  </div>

  <div className="main_sec_ip">
    <div className="card_header_top">
      <div className="main_sec_ip_icon">
        <TrendingUpIcon />
      </div>
      <span className="card_badge">TOP RATED</span>
    </div>
    <span>Grow Your Practice</span>
    <p>Build long-term patient trust, collect ratings, and boost your healthcare brand.</p>
  </div>
</div>
                </div>
              </div>
            </div>
          </div>
          <div class="registeration-heading text-center">
            <h2>
              Become a CaresAtHome <span> Caregiver Partner </span> in 5 Easy
              Steps
            </h2>
            <p>
              Follow a few simple steps to register as a CaresAtHome Partner and
              start offering your healthcare services.
            </p>
          </div>
        </div>
        <div class="partner-process">
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">1.</span>
              <h3>Login In / Register Yourself</h3>
              <p>
                Existing partners log in with mobile number and password; new
                partners sign up with mobile number and OTP verification.
              </p>
            </div>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">2.</span>
              <h3>Select Your Primary Service</h3>
              <p>
                Choose Caregiver (Nursing, Physiotherapy, Bedside Attendant) or
                Doctor Consultant (Video Call, At Clinic, At Home).
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">3.</span>
              <h3>Tell Us About Yourself</h3>
              <p>
                Add personal details: name, phone, email, state, city, address,
                pincode, gender, education, and experience.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">4.</span>
              <h3>Service, Fee &amp; Availability</h3>
              <p>
                Select your service, set your fee and availability (days &amp;
                time slots), then submit.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">5.</span>
              <h3>Registration Successfully</h3>
              <p>
                Your profile is under review; once verified, you get access to
                your dashboard and start receiving patient requests.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
        </div>
      </div>

      <div className="network_section">
        <div className="container-fluid">
          <div className="inner_network_section">
              <div className="heading_care_for">
                <h3 className="heading-about">Become a Partner with <span>CaresAtHome</span> </h3>
                <p className="pera-about">Empowering individual professionals and medical business providers on one unified platform.</p>
              </div>
              <div className="network_content_sec">
                <div className="row">
                  <div className="col-lg-5 col-md-5 col-12">
                    <div className="business_sec">
                      <span className="b2b">B2B & B2C Opportunities</span>
                      <h3>For Business Providers</h3>
                      <p>Medical Equipment Providers, Diagnostic Labs & Medical Stores</p>
                      <div className="business_box_prt">
                        <div className="business_icon_text">
                          <div className="only_icon_business">
                              <MedicalServicesIcon/>
                          </div>
                          <span>Medical Equipment Providers</span>
                        </div>
                          <div className="business_icon_text">
                          <div className="only_icon_business">
                              <ScienceOutlinedIcon/>
                          </div>
                          <span>Labs & Diagnostic Centers</span>
                        </div>
                          <div className="business_icon_text">
                          <div className="only_icon_business">
                              <StoreOutlinedIcon/>
                          </div>
                          <span>Medical Stores / Pharmacies</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-7 col-12">
                    <div className="Partner_sec">
                       <h4>Why Partner As A Business?</h4>
                       <div className="partner_icon-text_prt">
                         <div className="icon_only_partner">
                           <CheckOutlinedIcon/>
                         </div>
                         <h4 className="partner_title">No Subscription Charges <span>FREE FOR NOW</span></h4>
                         <p>Join the platform completely FREE of cost and expand your customer reach without upfront fees.</p>
                       </div>
                       <div className="partner_icon-text_prt">
                         <div className="icon_only_partner">
                           <CheckOutlinedIcon/>
                         </div>
                         <h4 className="partner_title">Showcase With B2B & B2C Pricing</h4>
                         <p>List products/services with B2B rates (for partners) & B2C rates (visible to direct users on app & web).</p>
                       </div>
                       <div className="partner_icon-text_prt">
                         <div className="icon_only_partner">
                           <CheckOutlinedIcon/>
                         </div>
                         <h4 className="partner_title">More Visibility. More Business.</h4>
                         <p>Reach a wide network of healthcare professionals, patients & local customers instantly.</p>
                       </div>
                        <div className="downd_btnss">
                    <Link
                      to="https://play.google.com/store/apps/details?id=com.letscare"
                      target="_blank"
                    >
                      <img src={downloadbuttonres1} alt="downloadbutton-1" />
                    </Link>
                    <Link
                      to="https://play.google.com/store/apps/details?id=com.letscare"
                      target="_blank"
                    >
                      <img src={downloadbuttonres2} alt="downloadbutton-2" />
                    </Link>
                  </div>
                    </div>
                  </div>
                </div>
              </div>
          </div> 
        </div>
      </div>

      <div class="registration-process-outer registration-process-outer-2">
        <div class="container-fluid">
          <div className="about_us_first_sec">
            <div className="row">
              <div className="col-lg-7 col-md-7 col-12">
                <div className="about_content">
                  <p className="title-about">Doctor Consultant</p>
                  <h4 className="heading-about">
                    Become a <span>Doctor Consultant Partner </span> with
                    CaresAtHome
                  </h4>
                  <p className="pera-about">
                    Join our network of healthcare professionals and extend your
                    medical expertise to patients who need trusted healthcare
                    support. At CaresAtHome, we aim to connect doctors with
                    patients seeking convenient, personalized healthcare
                    services, including home consultations and ongoing medical
                    guidance.{" "}
                  </p>
                  <p className="pera-about">
                    As a Doctor Consultant Partner, you can contribute your
                    clinical expertise, support better patient care, and help
                    make quality healthcare more accessible from the comfort of
                    home. Partner with us to build meaningful patient
                    relationships and become part of a healthcare network
                    focused on compassion, convenience, and quality care.
                  </p>
                </div>
              </div>
              <div className="col-lg-5 col-md-5 col-12">
                <div className="img_and_text_about">
                  <div className="content_nursing_img">
                    <img src={doctorRegister} alt="resistration-img-1" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="registeration-heading text-center">
            <h4>
              {" "}
              Join Our <span> Doctor Consultant</span> Network in 5 Simple Steps
            </h4>
            <p>
              Follow a few simple steps to register as a CaresAtHome Partner and
              start offering your healthcare services.
            </p>
          </div>
        </div>
        <div class="partner-process">
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">1.</span>
              <h3>Login In / Register Yourself</h3>
              <p>
                Existing doctors log in with mobile number and password; new
                doctors sign up with mobile number and OTP verification.
              </p>
            </div>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">2.</span>
              <h3>Select Your Primary Service</h3>
              <p>
                Choose Doctor Consultant, specifying consultation mode (Online
                Video Call, At Clinic, At Home).
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">3.</span>
              <h3>Tell Us About Yourself</h3>
              <p>
                Add personal details: name, phone, email, state, city, address,
                pincode, gender, education, and experience.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">4.</span>
              <h3>Choose Your Medical Expertis</h3>
              <p>
                Select your specialty, consultation mode, and fee; set your
                availability (days &amp; time slots), then submit.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">5.</span>
              <h3>Registration Successfully</h3>
              <p>
                Your profile is under review; once verified, you get access to
                your dashboard and start receiving patient consultations.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
